module.exports = __webpack_public_path__ + "static/media/hp-life.b73ab374.svg";